import React from 'react';
import { useMarketAggregates } from '../contexts/MarketAggregatesContext';

const OPTIONS_DAYS = [2, 5, 10, 20, 60];

const ForecastHorizonSelector: React.FC = () => {
  const { state, setMaxLeadTimeHours } = useMarketAggregates();

  const selectedDays = Math.round(state.maxLeadTimeHours / 24);

  return (
    <div className="flex items-center gap-2">
      <label className="text-xs font-medium text-gray-600 dark:text-gray-400 whitespace-nowrap">
        Forecast Horizon
      </label>
      <div className="flex bg-gray-100 dark:bg-gray-800 rounded-md">
        {OPTIONS_DAYS.map((days) => (
          <button
            key={days}
            onClick={() => setMaxLeadTimeHours(days * 24)}
            className={`px-3 py-1 text-xs font-medium rounded transition-colors whitespace-nowrap ${
              selectedDays === days
                ? 'bg-gray-900 dark:bg-gray-600 text-white shadow-sm'
                : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100'
            }`}
          >
            {days}d
          </button>
        ))}
      </div>
    </div>
  );
};

export default ForecastHorizonSelector;
